export default "__VITE_ASSET__Dgs_LInM__";